export default __webpack_public_path__ + "static/media/client41.7bdc3169.png";